export default __webpack_public_path__ + "static/media/icon_cart_gray.0cd4c156.svg";